export default function formHandler() {
  $('.form-register').on('submit', function (e) {
    e.preventDefault();
    const $this = $(this);

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      dataType: 'json',
      data: { action: 'gen_membership' },
      success: function (response) {
        $('input[name="membership"]').val(response.data);
        if ($('input[name="membership"]').val() !== '') {
          $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            dataType: 'json',
            data: { action: 'empty_cart' },
          });
          $this[0].submit();
        }
      },
      error: function (xhr, textStatus, errorThrown) {
        console.log(xhr);
      }
    });
  });

  $('input[name="search"]').val(location.search);
  const inputs = document.getElementsByClassName('form-control');

  Array.prototype.filter.call(inputs, function (input) {
    input.addEventListener('keyup', function (event) {
      input.classList.remove('is-invalid');

      if (input.checkValidity() === false) {
        input.classList.add('is-invalid');
      } else {
        input.classList.remove('is-invalid');
      }
    }, false);
  });
}
